export default () => ({
    data: null,
    receiptData: null, // copy so the checkout state can be reset for another order
    isProcessing: false, // a little ui helper, put into vuex because it was sprinkled everywhere up and down
    isAffirmPayFlow: false,
    isAutocompleteOff: true,
    hasOrderBeenPlaced: false,
})
